
import { defineComponent, ref } from 'vue'
import Home from './views/Home.vue'
import Bgm from '@/components/Bgm'

export default defineComponent({
  name: 'App',
  components: {
    Home,
    Bgm
  },
  setup () {
    return {
      disabled: ref(false)
    }
  }
})
